export const storageKeys = {
  TOKEN: 'JSMTID',
  IDP_TOKEN: 'JSMIDPTOKEN',
  GROUP_PRODUCTS_SELLERS: 'JSMSelectedGroupIndustry',
  USER_SELLERS: 'JSMSELLERSINFO',
  USER_INFO: 'JSMINFO',
  UNLEASH: 'unleash:repository:repo',
  UNLEASH_SESSION_ID: 'unleash:repository:sessionId',
}
